"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrespondenceTemplateAddresseeType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var CorrespondenceTemplateAddresseeType_Factory = /** @class */ (function () {
    function CorrespondenceTemplateAddresseeType_Factory() {
    }
    CorrespondenceTemplateAddresseeType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CorrespondenceTemplateAddresseeType1: model.CorrespondenceTemplateAddresseeType1,
            Description: model.Description,
        };
        return result;
    };
    CorrespondenceTemplateAddresseeType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CorrespondenceTemplateAddresseeType1: model.CorrespondenceTemplateAddresseeType1,
            Description: model.Description,
        };
        return result;
    };
    return CorrespondenceTemplateAddresseeType_Factory;
}());
exports.CorrespondenceTemplateAddresseeType_Factory = CorrespondenceTemplateAddresseeType_Factory;
